import Api from "./axiosVersion1";

export const createTicket = async (data) => {
    const response = await Api.post(`/create-ticket`, data);
    return response;
}